<template>
  <div>
    <Carousel />
    <Aboutmetro />
    <Activities />
    <MainPageGallery />
    <Slider />
    <Featured />
    <Association />
    <Testimonial />
    <Form />
    <Sponsors />
    <Footer />
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'
import Aboutmetro from '@/components/AboutMetro'
import Activities from '@/components/Activities'
import MainPageGallery from '@/components/MainGallery'
import Slider from '@/components/Slider'
import Featured from '@/components/Featured'
import Association from '@/components/Associations'
import Testimonial from '@/components/Testimonial'
import Sponsors from '@/components/Sponsors1'
import Form from '@/components/Form'
import Footer from '@/components/Footer'
// import Flickity from "vue-flickity"

export default {
  components:{
    Carousel,
    Aboutmetro,
    Activities,
    MainPageGallery,
    Slider,
    Featured,
    Association,
    Testimonial,
    Sponsors,
    Form,
    Footer
    
  }
}
</script>
